<div class="container-fluid py-4">
  <div class="row g-4">

    <!-- Pulse Score -->
    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body">
          <app-pulse-score-widget  [entityId]="tenantId" ></app-pulse-score-widget>
        </div>
      </div>
    </div>

    <!-- Monthly Overview -->
    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body">
          <app-monthly-overview-widget [tenantId]="tenantId"></app-monthly-overview-widget>
        </div>
      </div>
    </div>

    <!-- Critical Teams -->
    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body">
          <app-critical-teams-widget [tenantId]="tenantId"></app-critical-teams-widget>
        </div>
      </div>
    </div>

    <!-- Recommendations -->
    <div class="col-md-6">
      <div class="card h-100 shadow-sm">
        <div class="card-body">
          <app-recommendations-widget></app-recommendations-widget>
        </div>
      </div>
    </div>



  </div>
</div>
